module.exports = __webpack_public_path__ + "static/media/pill-coumadin.dc1d5def.svg";